// App.jsx
import React from 'react';
import MemoryGame from './components/MemoryGame';

const App = () => (
  <div className="App">
    <MemoryGame />
  </div>
);

export default App;
